import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Flex, message, List, Col, Row } from "antd";
import { CustomInput, CustomButton, CustomTitle } from "../../components";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext";
import { GetSingleCourierById, LinkAccount } from "../../api's/onboarding";
import shield from "../../assets/images/shield.png";

const ConnectFormModal = ({ closeModal, reset, data, onSuccess }) => {
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const { token, removeToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const navigate = useNavigate();
  const [courierModal, setCourierModal] = useState(["Client ID"])

  //reset field when component opens
  useEffect(() => {
    if (data && data?.required_inputs && Array.isArray(data?.required_inputs)) {
      setCourierModal(data?.required_inputs)
    }
  }, [data]);

  useEffect(()=>{
    if(courierModal){
      if(data?.id && (data?.status=="linked" || data?.status=="error")){
        GetSingleCourier(data?.id)
      }
    }

  },[courierModal,data])


  

  const GetSingleCourier = (id) => {
        showSpin();
        GetSingleCourierById(token, id)
            .then((res) => {
                const data = res?.data ? res.data : null;
                if (data) {
                    if (data?.data?.is_success) {
                      // let m = form.getFieldsValue(); 
                      // let updatedValues = { ...m }; 
                      // Object.keys(data?.data?.data?.couriers?.credentials).forEach((key) => {
                      //   if (updatedValues.hasOwnProperty(key)) { // Check if key exists in form values
                      //     updatedValues[key] = data?.data?.data?.couriers?.credentials[key]; // Assign new value
                      //   }
                      // });
                      form.setFieldsValue(data?.data?.data?.couriers?.credentials);
                      //form.setFieldsValue(updatedValues);
                    } else {
                        message.error(data?.data?.message);
                    }
                }
            })
            .catch((error) => {
                unauthorize(error)
            }).finally(() => {
                hideSpin();
            });
    }



  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const sendFormData = (model)=>{
    showSpin();
    setIsFormValid(true);
    LinkAccount(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data.is_success) {
            closeModal();
            onSuccess();
            message.success(data?.data?.message);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((err) => {
        unauthorize(err);
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  }

  const onFinishForm = (values) => {
    if (values && Object.keys(values).length > 0 && data?.id) {
      let model = {
        courier_id: data?.id,
        credentials: { ...values }
      }
     model.client_id = data?.id;
     model.client_secret = data?.id;
      sendFormData(model);
    }
  };

  const handleCancel = () => {
    let model = {
      courier_id: data?.id,
      credentials: null
    }
   sendFormData(model);
  };

  return (
    <>
      <div>
        <CustomTitle
          text="Instructions"
          fontSize="14px"
          fontWeight="500"
          color="black"
        />
        <p
          dangerouslySetInnerHTML={{
            __html: data?.instructions
          }}
        ></p>
        {/*             
            <List
              split={false}
              itemLayout="horizontal"
              dataSource={data?.instructions}
              renderItem={(item, index) => (
                <List.Item style={{ padding: "0" }}>
                  <List.Item.Meta
                    title={
                      item.isLink ? (
                        <>
                          {index + 1}. {item.title}
                          <a
                            href={item.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "underline" }}
                          >
                            {item.linkText}
                          </a>
                        </>
                      ) : (
                        `${index + 1}. ${item.title}`
                      )
                    }
                  />
                </List.Item>
              )}
            /> */}
      </div>

      <Form
        form={form}
        name="validateOnly"
        initialValues={{
          client_id: "", // Default initial value
          client_secret: "", // Default initial value
        }}
        layout="vertical"
        labelCol={{
          span: 16,
        }}
        wrapperCol={{
          span: 24,
        }}
        autoComplete="off"
        onFinish={onFinishForm}
      >

        {/* <Row gutter={12}>
          <Col span={14} style={{ marginTop: '20px' }}>
            <Form.Item
              label="Username"
              name="client_id"
              rules={[
                {
                  required: true,
                  message: "Please input your username",
                },
              ]}
              style={{ marginBottom: "10px" }}
            >
              <CustomInput
                height="36px"
                width="100%"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
                suffix={<img src={shield} alt="shield" />}
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="client_secret"
              rules={[
                {
                  required: true,
                  message: "Please input your password",
                },
              ]}
            >
              <CustomInput
                height="36px"
                width="100%"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                suffix={<img src={shield} alt="shield" />}
              />
            </Form.Item></Col></Row> */}

        <Row gutter={12}>
          <Col span={12} >
            {courierModal.map((element) => (
              <Form.Item
                label={element}
                name={element}
                labelCol={{ span: 24 }} 
                wrapperCol={{ span: 24 }} 
                style={{ paddingTop: "12px" }}
                rules={[
                  {
                    required: true,
                    message: `Please input ${element ? element : "value"}`,
                  },
                ]}
              >
                <CustomInput
                  placeholder={`Paste ${element ? element : "value"} here`}
                  height="36px"
                  width="100%"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                // suffix={<img src={shield} alt="shield" />}
                />
              </Form.Item>
            ))}
          </Col>
        </Row>



        <React.Fragment key="footer-actions">
          <Flex gap="16px" justify="end" style={{ marginTop: "32px" }}>
            <CustomButton
              key="button1"
              onClick={handleCancel}
              text={"I'm okay with basic tracking"}
              bgColor={"#F3F3F3"}
              color="black"
              fontSize="14px"
              fontWeight="500"
              boxShadow="none"
              height="40px"
            />
            <CustomButton
              key="button2"
              text={"Confirm"}
              bgColor="black"
              color="white"
              height="40px"
              width="80px"
              fontSize="14px"
              fontWeight="500"
              boxShadow="none"
              borderRadius="8px"
              isFormValid={isFormValid}
              htmlType="submit"
            />
          </Flex>
        </React.Fragment>
      </Form>
    </>
  );
};

export default ConnectFormModal;
